import {
  OptionButtonGroup,
  OptionButtonWithRadio,
} from '@pinecast/common/OptionButton';
import {FormattedMessage} from '@pinecast/i18n';
import {useColors, useCSS} from '@pinecast/styles';
import * as React from 'react';

export type Frequency = 'oneTime' | 'recurring';

const TipFrequency = ({
  onChange,
  value,
}: {
  onChange: (frequency: Frequency) => void;
  value: Frequency;
}) => {
  const css = useCSS();
  const designColors = useColors();
  const headingId = React.useId();

  // Both options match the height the pair had when each held a radio of its
  // own, rather than shrinking to a line of text.
  const optionStyle = {justifyContent: 'center', minHeight: '46px'};

  return (
    <div
      className={css({display: 'flex', flexDirection: 'column', gap: '14px'})}
    >
      <h2
        id={headingId}
        className={css({
          fontFamily: 'Monument Grotesk Bold',
          fontSize: '18px',
          fontWeight: 400,
          lineHeight: '24px',
          margin: 0,
        })}
      >
        <FormattedMessage
          description="Label for subscription duration"
          defaultMessage="Subscribe for one month or set up a recurring subscription?"
        />
      </h2>
      <OptionButtonGroup
        aria-labelledby={headingId}
        direction="horizontal"
        wrapperStyle={{
          display: 'flex',

          '@media (max-width: 460px)': {
            flexDirection: 'column',
          },
        }}
      >
        <OptionButtonWithRadio
          onClick={() => {
            onChange('oneTime');
          }}
          selected={value === 'oneTime'}
          style={optionStyle}
        >
          <FormattedMessage
            description="Label for option to send a one-month subscription"
            defaultMessage="Just one month"
          />
        </OptionButtonWithRadio>
        <OptionButtonWithRadio
          onClick={() => {
            onChange('recurring');
          }}
          selected={value === 'recurring'}
          style={optionStyle}
        >
          <FormattedMessage
            description="Label for option to become a recurring donor"
            defaultMessage="Recurring monthly"
          />
        </OptionButtonWithRadio>
      </OptionButtonGroup>
      <p
        className={css({
          color: designColors.contentTextMuted,
          fontSize: '14px',
          lineHeight: '20px',
          margin: 0,
        })}
      >
        <FormattedMessage
          description="Copy for how often tips are charged"
          defaultMessage="You can change or cancel a subscription at any time. No surprises."
        />
      </p>
    </div>
  );
};

export default TipFrequency;
